import { registerRoute } from '../router';
import { apiFetch } from '../api';
import { escapeHtml } from '../format';

interface AuditLogEntry {
  id: string;
  userName: string | null;
  action: string;
  targetType: string;
  targetId: string | null;
  status: number;
  ip: string | null;
  createdAt: string;
}

function renderRows(entries: AuditLogEntry[]): string {
  if (entries.length === 0) {
    return `<p style="color:var(--clr-text-muted);">No activity recorded yet.</p>`;
  }

  return `
    <div style="display:flex;flex-direction:column;gap:6px;">
      ${entries
        .map(
          (entry) => `
        <div class="card" style="display:flex;align-items:center;justify-content:space-between;gap:16px;padding:14px 18px;">
          <div style="min-width:0;">
            <span style="font-weight:600;">${escapeHtml(entry.userName ?? 'external')}</span>
            <code style="margin-left:8px;font-size:0.82rem;color:var(--clr-text-muted);">${escapeHtml(entry.action)}</code>
            ${entry.targetId ? `<span style="margin-left:8px;font-size:0.78rem;color:var(--clr-text-dim);">${escapeHtml(entry.targetId)}</span>` : ''}
          </div>
          <div style="display:flex;align-items:center;gap:12px;flex-shrink:0;">
            <span style="font-size:0.78rem;color:var(--clr-text-dim);">${escapeHtml(entry.ip ?? '—')}</span>
            <span class="badge badge--success">${entry.status}</span>
            <span style="font-size:0.78rem;color:var(--clr-text-dim);min-width:130px;text-align:right;">${escapeHtml(entry.createdAt)}</span>
          </div>
        </div>`,
        )
        .join('')}
    </div>
  `;
}

registerRoute({
  path: '/audit-logs',
  title: 'Audit Logs',
  render: ({ container }) => {
    container.innerHTML = `
      <div class="page-header">
        <h1>Audit Logs</h1>
        <p>The last 200 successful changes across the app — who did what, when, and from where.</p>
      </div>
      <div id="audit-logs-list">Loading…</div>
    `;

    apiFetch<AuditLogEntry[]>('/api/audit-logs')
      .then((entries) => {
        container.querySelector('#audit-logs-list')!.innerHTML = renderRows(entries);
      })
      .catch(() => {
        container.querySelector('#audit-logs-list')!.textContent = 'Could not load audit logs.';
      });
  },
});
